// import 'regenerator-runtime/runtime'
import './warning'
export * from './blueprintjs'
export * from './customHooks'
export * from './popover2'
import * as apollo from './apollo';
import _ from 'lodash'
export {_}
import * as immer from 'immer'
export {immer}
import ImageAnnotationComponent from 'react-image-annotation'
export {ImageAnnotationComponent}

import io, {Socket} from 'socket.io-client'
export {io, Socket}

import html2canvas from 'html2canvas'
export {html2canvas}

export {useInfiniteQuery, useQuery} from 'react-query'
import 'react-resizable/css/styles.css'
export {Resizable, ResizableBox} from 'react-resizable'

import {Carousel as ReactResponsiveCarousel} from './react-responsive-carousel'
import './react-responsive-carousel/lib/styles/carousel.min.css'
export {ReactResponsiveCarousel}

import Postmate from 'postmate'
export {Postmate}

import dd from 'deepdash'
const deepdash = dd(_)
export {deepdash}

export * from './immer'
export {toHeaderCase} from 'js-convert-case'

// import '@inovua/reactdatagrid-community/index.css'
import './reactDataGrid'

import Iframe from 'react-iframe'
export {Iframe}

import slugify from 'slugify'
export {slugify}

import stringify from 'json-stable-stringify'
export {stringify}

import SplitterLayout from 'react-splitter-layout';
import 'react-splitter-layout/lib/index.css';
import classNames from 'classnames'
//import InfiniteScroll from 'react-infinite-scroller'
import lockr from 'lockr'
export * from './mobx'
import React, {Suspense, memo, useState, useEffect, useCallback, useContext, useMemo, useReducer, useLayoutEffect, useRef, Fragment} from 'react'
export {React}
export {useLayoutEffect, useMemo, useContext, useState, useEffect, useReducer, useRef, useCallback, Fragment} from 'react'
// export {findDOMNode} from 'react-dom'

export {useAsync, useDebounce} from 'react-use'
import * as ReactDOM from 'react-dom'
import * as jwt from 'jsonwebtoken'
import * as qs from 'query-string'
import moment from 'moment'
import SwipeableViews from 'react-swipeable-views'
import tinycolor from 'tinycolor2'
import TimeAgo from 'react-timeago'
export * from './mui'
import * as ReactDOMServer from 'react-dom/server'
const {findDOMNode} = ReactDOM
export {ReactDOMServer}
import IdleTimer from 'react-idle-timer'
import memoize from 'memoize-one'
import InfiniteScroll from 'react-infinite-scroller'
import AutoSizer from "react-virtualized-auto-sizer"
import {default as Fuse} from 'fuse.js/dist/fuse.common'
import axios, {AxiosInstance} from 'axios'
export {axios}
import pluralizeFn from 'pluralize'
export const pluralize = (word: string, number?: number, inclusive?: boolean) => {
  if (word?.endsWith(')')) { return word}
  if (word?.toLowerCase().indexOf('active') != -1) { return word}
  return pluralizeFn(word, number, inclusive)
}

import {Img} from 'react-image'
export {Img}
import * as jsondiff from 'jsondiffpatch'
import 'jsondiffpatch/dist/formatters-styles/html.css'
import Push from 'push.js'
import currencyToSymbolMap from 'currency-symbol-map/map'

export {useHotkeys} from 'react-hotkeys-hook'

import VisibilitySensor from 'react-visibility-sensor'
import scrollIntoView from 'smooth-scroll-into-view-if-needed'

import {Highlighter} from './Highlighter'
export {scrollIntoView, Push, jsondiff, Suspense, Fuse, qs, apollo, classNames, lockr, jwt, moment, SwipeableViews, IdleTimer, memoize, memo, InfiniteScroll, AutoSizer, Highlighter, VisibilitySensor, tinycolor, TimeAgo};
export {SplitterLayout, findDOMNode, ReactDOM}
export {withApollo, Mutation, Subscription, Query, ApolloProvider, ApolloLink, ApolloClient, QueryResult} from './apollo'

import styled, {css} from 'styled-components'

export {styled, css}

// export * from './mobx'
export {withRouter, Link, Redirect, SentryRoute, match, RouteProps, RouteComponentProps, Switch, Route} from './react-router'

import * as Sentry from '@sentry/react'
export {Sentry}

import useIntersectionObserver from '@react-hook/intersection-observer'
export {useIntersectionObserver}
export * from './lodash'

export { currencyToSymbolMap }

import {unstable_trace as reactTrace} from 'scheduler/tracing'
export {reactTrace}

import {DateRangePicker, DateRange} from '@blueprintjs/datetime'
export {DateRangePicker, DateRange}
import(/* webpackChunkName: "suneditor" */ 'suneditor/dist/css/suneditor.min.css')

// export * from './froala'


// WEBPACK FOOTER //
// ./src/shared/components/3rd-party/index.ts